import { Link } from "@inertiajs/react"
import { Button } from "@radix-ui/themes"
import type { ComponentProps } from "react"

type LinkButtonProps = {
  href: string
} & Omit<ComponentProps<typeof Button>, "asChild">

export default function LinkButton({ href, children, ...props }: LinkButtonProps) {
  return (
    <Button asChild {...props}>
      <Link href={href}>{children}</Link>
    </Button>
  )
}
